module.exports = __webpack_public_path__ + "img/catstagram.c1324c44.png";